<template>
    <section v-loading.fullscreen.lock="allLoadLoading">
        <!-- <el-button type="warning" v-if="IsInput!=''" @click="back" plain icon="el-icon-back">返回</el-button> -->
        <el-row>
            <el-col :span="16">
                <div class="grid-content bg-purple" style="margin-top: 10px; color: #495060; width: 1200PX;">
                    <span style="margin-left: 10px">档案号：<el-tag type="success" v-if="this.assessmentFile.Id != ''">{{
                        this.assessmentFile.Number }}</el-tag></span>
                    <span style="margin-left: 10px">负责人：
                        <el-tag type="success" v-if="
                            this.assessmentFile.Id != '' &&
                            this.assessmentFile.ScoreUserName != null
                        ">{{ this.assessmentFile.ScoreUserName }}
                        </el-tag>
                    </span>
                    <transition name="el-zoom-in-top">
                        <label v-if="
                            this.assessmentFile.State == 4 || this.assessmentFile.State == 3
                        ">
                            <span style="margin-left: 50px">总得分：</span>
                            <span style="font-family: 微软雅黑; font-size: 25px; color: #e6a23c">{{
                                this.assessmentFile.Score }}</span>
                        </label>
                    </transition>
                    <span style="margin-left: 10px">达标模块数：
                        <el-tag type="success">
                            {{ this.passCount }}
                        </el-tag>
                    </span>
                    <span style="margin-left: 10px">未达标模块数：
                        <el-tag type="warning">
                            {{ this.fallCount }}
                        </el-tag>
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple"
                    style="float: right;margin-top: 10px;margin-right: 10px;color: #495060;">
                    <el-divider direction="vertical"></el-divider>
                    <span>评级状态：</span><el-tag type="warning" v-if="this.assessmentFile.State == '1'">未提交</el-tag>
                    <el-tag type="success" v-if="this.assessmentFile.State == '2'">已提交</el-tag>
                    <el-tag type="info" v-if="this.assessmentFile.State == '3'">未通过</el-tag>
                    <el-tag type="success" v-if="this.assessmentFile.State == '4'">已通过</el-tag>
                    <el-tag type="success" v-if="this.assessmentFile.State == '5'">已考核</el-tag>
                    <el-tag type="success" v-if="this.assessmentFile.State == '6'">已归档</el-tag>
                </div>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <div style="margin-top: 20px">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="IsStandards" label="是否达标" width="80" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.IsStandards === true" effect="dark" type="success">已达标</el-tag>
                        <el-tag v-if="scope.row.IsStandards === false" effect="dark" type="warning">未达标</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="StIndex" label="标准序号" width="80px" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="ReviewContent" label="评审模块" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="Stoverview" label="标准概述" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="Stscore" label="标准分值" width="80px" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="Zrbm" label="责任部门" width="120px" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="PersonLiableName" label="责任人" width="120px" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="CreateTime" label="评审时间" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="Score" label="得分" width="80px" :show-overflow-tooltip="true">
                </el-table-column>
            </el-table>
        </div>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize"
                :total="total" style="float: right"></el-pagination>
        </el-col>
    </section>
</template>
<script>
import {
    getAssessmentFile,
    getEvaluationAgencyList,
    GetModulePassInfo,
} from "../../api/EvaluationAgency/EvaluationAgency";
import { GetCheck } from "../../api/RatingManage/RatingManage";

export default {
    props: ["ratingData", "checkpValue", "fileManagermentPassId"],
    data () {
        return {
            passCount: 0,
            fallCount: 0,
            allLoadLoading: false,
            reason: "",
            assessmentFileState: "", //档案审核状态
            IsInput: "",
            fileManagermentFileId: null, //档案ID
            input: "",
            total: 0,
            pageSize: 10,
            //考核档案数据
            assessmentFile: {
                HospitalName: "",
                Number: "",
                Id: "",
                State: "",
                ScoreUserName: "",
            },
            pageIndex: 1,
            tableData: [],
            loading: false,
            checkData: [],
            checkValue: "",
        };
    },
    computed: {},
    mounted () { },
    watch: {},
    created () {
        this.loadApiData();
    },
    methods: {
        async loadApiData () {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            //获取考核表
            await this.GetCheckData();
            //加载考核档案数据
            await this.loadAssessmentFile();
            if (this.assessmentFile.Id != "") {
                this.getModulePassInfo();
            }
            loading.close();
        },
        //获取考核表
        async GetCheckData () {
            let para = {
                page: 1,
                key: "",
                pageSize: 1000,
            };
            await GetCheck(para).then((res) => {
                console.log(res.data);
                if (res.data.success) {
                    this.checkData = res.data.response.data;

                    if (this.checkData.length > 0) {
                        this.checkValue = this.checkData[0].Id;
                    }
                }
            });
        },
        //获取考核档案数据
        async loadAssessmentFile () {
            var parms = {
                // chenckId: this.checkValue,
                fileId: this.fileManagermentFileId,
            };
            await getAssessmentFile(parms).then((res) => {
                this.assessmentFile = res.response;
                if (this.assessmentFile == null) {
                    this.$message({
                        message: "还未完成评价考核",
                        type: "warning",
                    });
                    this.tableData = [];
                    this.dataCount = 0;
                    this.assessmentFile = {
                        HospitalName: "",
                        Number: "",
                        Id: "",
                        State: "",
                        ScoreUserName: "",
                    };
                } else {
                    if (
                        this.assessmentFile.State == 3 ||
                        this.assessmentFile.State == 4
                    ) {
                        this.assessmentFileState = this.assessmentFile.State;
                        this.reason = this.assessmentFile.Reason;
                    }
                    this.handleQuery();
                }
            });
        },
        handleCurrentChange (val) {
            this.pageIndex = val;
            this.handleQuery();
        },
        //获取列表
        async handleQuery () {
            let parms = {
                fileId: this.assessmentFile.Id,
                key: this.input,
                page: this.pageIndex,
                intPageSize: this.pageSize,
                IsRatingAgency: false,
            };
            await getEvaluationAgencyList(parms).then((res) => {
                this.total = res.response.dataCount;
                this.tableData = res.response.data;
            });
        },
        getModulePassInfo () {
            let para = {
                fileId: this.assessmentFile.Id,
            };
            GetModulePassInfo(para).then((res) => {
                this.passCount = res.data.response.PassCount;
                this.fallCount = res.data.response.FallCount;
            });
        },
    },
};
</script>


<style lang="less" scoped>
::v-deep .el-icon-close:before {
    font-size: 30px !important;
}
</style>